function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "ic-warning",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2002 0C15.723 0 20.2002 4.47715 20.2002 10C20.2002 15.5228 15.723 20 10.2002 20C4.67735 20 0.200195 15.5228 0.200195 10C0.200195 4.47715 4.67735 0 10.2002 0ZM10.2002 13C9.64791 13 9.2002 13.4477 9.2002 14C9.2002 14.5523 9.64791 15 10.2002 15C10.7525 15 11.2002 14.5523 11.2002 14C11.2002 13.4477 10.7525 13 10.2002 13ZM10.2002 5C9.68736 5 9.26469 5.38604 9.20692 5.88338L9.2002 6V11C9.2002 11.5523 9.64791 12 10.2002 12C10.713 12 11.1357 11.614 11.1935 11.1166L11.2002 11V6C11.2002 5.44772 10.7525 5 10.2002 5Z",
  fill: "#CC3326"
});

function SvgIcWarningRedCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningRedCircle);
export default __webpack_public_path__ + "static/media/ic-warning-red-circle.919df311.svg";
export { ForwardRef as ReactComponent };